/**
 * Corespondența pas wizard (index 0-based) → chei de pas din motorul de flux
 * (packages/common/src/flows/dermato.flow.ts). Un index poate avea mai multe chei.
 */
export const DERMATO_STEP_KEYS: string[][] = [
  ['enrollment'],
  ['anamnesis'],
  ['fotofinderReport'],
  ['lesions'],
  ['abcde'],
  ['dermatoscopy'],
  ['videoAi'],
  ['screeningResult'],
  ['biopsy'],
  ['histopathology'],
  ['diagnosis'],
  ['treatment'],
  ['surgery'],
  ['surgicalHistopathology'],
  ['followUp', 'outcome'],
];

/** Pașii care se semnează per leziune (scopeId = lesionId). */
export const DERMATO_LESION_SCOPED_KEYS = new Set([
  'abcde',
  'dermatoscopy',
  'videoAi',
  'biopsy',
  'histopathology',
  'diagnosis',
  'treatment',
  'surgery',
  'surgicalHistopathology',
  'followUp',
  'outcome',
]);

/**
 * Indexul de ecran (0-based) pentru fiecare pas de flux (0-based).
 *
 * Motorul de flux are 18 pași (`packages/common/src/flows/dermato.flow.ts`),
 * iar wizardul are 15 ecrane (`dermatoSteps.tsx`). Nu toți pașii de flux au
 * ecran propriu:
 *   - `screeningNegative` (8) e un marker de fază (programarea recontrolului) →
 *     se deschide ecranul „Rezultat screening";
 *   - `followUp` (15) + `outcome` (16) împart ecranul „Follow-up / Outcome";
 *   - `closed` (17) e marker de fază (confirmarea închiderii) → ecranul
 *     „Follow-up / Outcome".
 *
 * Fără această mapare, `DERMATO_STEP_COMPONENTS[currentStep]` cu currentStep
 * în 0..17 returna `undefined` pentru indicii 15..17 și deschidea ecranul de
 * înrolare, iar clicurile pe „Recontrol programat"/„Outcome"/„Închidere episod"
 * deschideau ecranul greșit (ex. „Biopsie").
 */
export const DERMATO_SCREEN_BY_FLOW_INDEX: readonly number[] = [
  0, //  0 enrollment
  1, //  1 anamnesis
  2, //  2 fotofinderReport
  3, //  3 lesions
  4, //  4 abcde
  5, //  5 dermatoscopy
  6, //  6 videoAi
  7, //  7 screeningResult
  7, //  8 screeningNegative → ecranul „Rezultat screening"
  8, //  9 biopsy
  9, // 10 histopathology
  10, // 11 diagnosis
  11, // 12 treatment
  12, // 13 surgery
  13, // 14 surgicalHistopathology
  14, // 15 followUp
  14, // 16 outcome
  14, // 17 closed → ecranul „Follow-up / Outcome"
];

/**
 * Pasul de flux „primar" al fiecărui ecran (15 intrări).
 * Titlul, descrierea și numărul afișate în antet provin din acest pas, deci
 * antetul rămâne coerent cu numerotarea din sidebar.
 */
export const DERMATO_PRIMARY_FLOW_INDEX_BY_SCREEN: readonly number[] = [
  0, 1, 2, 3, 4, 5, 6, 7, 9, 10, 11, 12, 13, 14, 15,
];

/**
 * Pași de flux fără ecran propriu — sunt markeri de fază și se afișează
 * dimișat în sidebar (nu sunt niciodată „pasul curent").
 */
export const DERMATO_PHASE_ONLY_FLOW_INDEXES: readonly number[] = [8, 17];

/** Numărul de ecrane ale wizard-ului dermato. */
export const DERMATO_SCREEN_COUNT = DERMATO_STEP_KEYS.length;
